import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Home } from 'lucide-react';
import SEO from '@/components/SEO';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

const Imprint = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const userLang = navigator.language.split('-')[0] || 'de';
        const response = await axios.get(`${API}/api/legal/imprint?language=${userLang}`);
        if (response.data.content) {
          setContent(response.data.content);
        }
      } catch (error) {
        console.error('Error loading imprint:', error);
        setContent(getDefaultContent());
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  const getDefaultContent = () => {
    return `<h1>Imprint / Impressum</h1>
<p class="text-sm text-muted-foreground">Legal Information</p>

<h2>Service Provider</h2>
<p>
  <strong>Debatefy.online</strong><br />
  [Your Company Name]<br />
  [Your Address]<br />
  [City, Postal Code]<br />
  [Country]
</p>

<h2>Contact</h2>
<p>
  Email: [Your Contact Email]<br />
  Website: https://debatefy.online
</p>

<h2>Represented by</h2>
<p>
  [Name of Legal Representative]<br />
  [Title/Position]
</p>`;
  };

  return (
    <>
      <SEO 
        title="Imprint - Debatefy"
        description="Legal information and imprint for Debatefy.online"
        canonical="https://debatefy.online/imprint"
      />
      <div className="feature-detail-page">
        <div className="feature-detail-container">
          <div className="feature-detail-header">
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="home-button"
            >
              <Home className="mr-2 h-4 w-4" />
              Home
            </Button>
          </div>

          <Card className="feature-detail-card">
            <CardContent className="feature-detail-content">
              <div className="content-text">
                {loading ? (
                  <div className="text-center py-8">Loading...</div>
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Imprint;
